<div class="advanced-settings">
  <div class="content full-height">

    <div class="content__title">Intro</div>
    <div class="w-100 h-100 d-flex flex-column justify-content-start align-items-end">

      <div class="wizcard-container">

        <div class="chat-bubble shadow"
          style="position: absolute; bottom: 90%; right: 20%; border: 1px solid var(--secondary); ">
          <span #wizardText></span>
          <span class="cursor">|</span>

        </div>
        <img #wizard src="../../../assets/images/w2.jpeg" style="width: 100%;" />

      </div>

    </div>
  </div>
</div>